import gql from 'graphql-tag'

const createOrUpdatePersonalSummaryMutation = gql`
  mutation createOrUpdatePersonalSummary($expertId: String!, $input: PersonalSummaryInput!) {
    createOrUpdatePersonalSummary(expertId: $expertId, input: $input)
  }
`

export default createOrUpdatePersonalSummaryMutation
